import { addDays, addMilliseconds, isValid, subMilliseconds } from 'date-fns'
import { formatInTimeZone, getTimezoneOffset } from 'date-fns-tz'

import { formatTodayIso } from './format'

const time = {
  ms: { Second: 1000, Minute: 1000 * 60, Hour: 1000 * 60 * 60 },
}

const isoFormat = "yyyy-MM-dd'T'HH:mm:ss.SSSXXX"

const date = {
  today: () => new Date(),
  now: () => Date.now(),
  future: (ms = 0) => date.now() + ms,
  inNDays: (n: number) => addDays(date.today(), n),
  parseZonedTime: (value: string) => {
    const [iso, timeZone] = value.split('|') as [string, string]
    const zoned = formatInTimeZone(iso, timeZone, isoFormat)
    const today = formatTodayIso(zoned)
    return new Date(today).toISOString()
  },
  toZonedDate: (value: number | Date, timeZone: string) => {
    const offset = getTimezoneOffset(timeZone)
    return offset < 0 ? subMilliseconds(value, offset) : addMilliseconds(value, offset)
  },
}

const getValidDateTime = (dateTime?: number) => (dateTime && isValid(dateTime) ? dateTime : new Date().getTime())

export { getValidDateTime, date, time }
